<template>
  <ion-toolbar>
    <ion-buttons
      slot="start"
      v-if="
        $store.state.pages.auth.back.length ||
        routeName == 'profile_job_seeker_universitites'
      "
    >
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons
      slot="end"
      v-if="routeName !== 'profile_job_seeker_universitites'"
    >
      <ion-button @click="skip" class="pill next-pill-button">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Universities</h1>
          <span>{{
            universitiesCustomFields.length > 0
              ? universitiesCustomFields[0].label
              : ""
          }}</span>
        </div>
        <div class="brand-icon">
          <SvgIcon
            name="brandIcon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          />
        </div>
      </div>
      <el-form
        class="full_page"
        :label-position="'top'"
        @submit.prevent="goNext('userForm')"
      >
        <el-form-item prop="schedule" class="job_filters_form_checkbox">
          <template v-if="universitiesCustomFields.length > 0">
            <template
              v-for="(field, index) in universitiesCustomFields"
              :key="index"
            >
              <template v-if="field.fieldType === 'select'">
                <el-select
                  class="skill-search-selector custom-select"
                  v-model="form.selectedValues"
                  popper-class="normal-select"
                  filterable
                  placeholder="Select options"
                  @change="(value) => handleSelectChange(value, field, index)"
                >
                  <el-option
                    v-for="(value, i) in field.values"
                    :key="i"
                    :label="value.label"
                    :value="value.label"
                  ></el-option>
                </el-select>
                <div v-for="(value, i) in field.values" :key="i">
                  <el-input
                    v-if="isDynamicSelected(value)"
                    v-model="form[value.label]"
                    :placeholder="`Enter ${value.label}`"
                    class="others"
                    :maxlength="100"
                  ></el-input>
                </div>
              </template>
              <el-form-item-error v-if="v$.selectedValues.$error">
                {{ v$.selectedValues.$errors[0].$message }}
              </el-form-item-error>
            </template>
          </template>
        </el-form-item>
        <el-form-item class="button_submit mb0">
          <el-button
            :disabled="isSubmitDisabled"
            class="submit_page w-full"
            type="blue"
            @click="goNext('userForm')"
          >
            Continue
          </el-button>
        </el-form-item>
      </el-form>
      <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon
          name="bgIcon"
          class="bg-icon"
          width="174"
          height="174"
          viewBox="0 0 174 174"
          fill="none"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject, onBeforeMount, ref, reactive, computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import SvgIcon from "@/components/Svg/SvgIcon.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const $route = useRoute();
    const routeName = $route.name;

    const universitiesCustomFields = ref([]);
    console.log("🚀 ~ setup ~ customFields1:", universitiesCustomFields);
    console.log($store.getters.getJobFilters.schedule);
    const userData = $store.getters.GET_USER_DATA;

    const form = reactive({
      // selectedValues: ref(userData.customFields?.universities?.[0]?.value || []),
      // Others: ref(userData.customFields?.universities?.find(item => item.value === "Others")?.otherValue || null)
      selectedValues: userData.customFields?.universities?.[0]?.value
        ? userData.customFields?.universities?.[0]?.value
        : "",
      Others: userData.customFields?.universities?.find(
        (item) => item.value === "Others"
      )?.otherValue
        ? userData.customFields?.universities?.find(
            (item) => item.value === "Others"
          )?.otherValue
        : "",
    });

    const rules = computed(() => {
      return {
        selectedValues: {
          required: helpers.withMessage("Please enter the role", required),
        },
      };
    });
    const v$ = useVuelidate(rules, form);
    const goBack = async () => {
      if (routeName == "profile_job_seeker_universitites") {
        $router.push({
          name: "basic_profile_job_seeker",
        });
      } else {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
          name: back,
        });
      }
    };

    const isDynamicSelected = (value) => {
      return (
        form.selectedValues.includes(value.label) && value.showTextbox === true
      );
    };

    const goNext = async () => {
      const result = await v$.value.$validate();

      if (!result) {
        alert("The form has errors");
        return;
      } else {
        const values = [];

        const selectedValue = form.selectedValues;
        console.log("🚀 ~ goNext ~ selectedValues:", selectedValue);
        const otherValue = form[selectedValue] ? form[selectedValue] : "";
        values.push({ value: selectedValue, other_value: otherValue });
        const payload = [
          {
            key: "universities",
            values: values,
          },
        ];

        try {
          await $store.dispatch("SAVE_USER_UNIVERSITY_DATA", payload);
          if (routeName == "profile_job_seeker_universitites") {
            $router.push({
              name: "basic_profile_job_seeker",
            });
          } else {
            $router.push({
              name: "jobseeker_auth_registration",
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    const skip = () => {
      (async () => {
        try {
          $store.dispatch("addAuthPageBack", $route.name);
          $router.push({
            name: "jobseeker_auth_registration",
          });
        } catch (error) {
          console.log(error);
        }
      })();
    };

    const validateField = (fieldName) => {
      // Trigger validation for the specified field
      v$.value[fieldName].$touch();
    };

    onMounted(() => {
      setPageClassGlobal("global_auth_universities_page");
    });

    onBeforeMount(async () => {
      try {
        const response = await $store.dispatch("GET_CUSTOM_FIELDS");
        console.log("🚀 ~ onBeforeMount ~ check:", response);
        universitiesCustomFields.value = response.data?.universities ?? [];
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    });

    const handleSelectChange = (selectedValue, field, index) => {
      console.log("🚀 ~ handleSelectChange ~ index:", index);
      console.log("🚀 ~ handleSelectChange ~ selectedValue:", selectedValue);

      field.values.forEach((value) => {
        const ruleKey = value.label;

        // Check if the current value needs a textbox
        if (value.showTextbox && form.selectedValues.includes(value.label)) {
          // Add validation rule for the dynamic input
          if (!rules.value[ruleKey]) {
            rules.value[ruleKey] = { required };
          }

          // Initialize the dynamic field with an empty value if not already present
          if (!form[ruleKey]) {
            form[ruleKey] = ref(""); // Use a ref for reactivity
          }

          // Trigger validation for the new field
          v$.value.$touch(ruleKey);
        } else if (!form.selectedValues.includes(value.label)) {
          // If the option is deselected, remove its validation and field
          delete rules.value[ruleKey];
          delete form[ruleKey];
        }
      });
    };

    const isSubmitDisabled = computed(() => {
      return (
        Object.values(form).some((value) => value.length == 0) ||
        v$.value.$pending ||
        v$.value.$error
      );
    });

    return {
      goBack,
      goNext,
      handleSelectChange,
      isDynamicSelected,
      universitiesCustomFields,
      form,
      rules,
      v$,
      validateField,
      isSubmitDisabled,
      skip,
      userData,
      routeName,
    };
  },
};
</script>
